/**
 * Formats a date into a custom string.
 *
 *  returns a string in the format "DAY, dd MONTH at hh:mm am/pm".
 *
 * @param date The date to format.
 * @param locale The locale to use for formatting (defaults to 'en-US').
 * @returns A string representing the formatted date.
 */
export function formatCustomDate(date: Date, locale: string = 'en-US') {
  const dayMonth = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
  }).format(date);

  const time = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
    .format(date)
    .toLowerCase();

  return `${dayMonth} ${locale === 'en' ? 'at' : ''} ${time}`;
}

export function sanitizeInput(input: string) {
  let sanitized = input.replace(/^ +/, '');
  sanitized = sanitized.replace(/ {2,}/g, ' ');

  return sanitized;
}
